import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const ServiceHubForm = withAsync({
    loader: lazyForPaint(() => {
        return import(/* webpackChunkName: "service-hub-form" */ './service-hub-form');
    }),
});
